import {doc} from './docs.js';
import ZToggle from '../custom/ZToggle.js';

doc(
    "toggle",
    {
    },
    "Toggles 0/1 when clicked",
    () => 0,
    {
        inlets: 0
    });

export const toggle = (object) => {
    let ztoggle = new ZToggle(object);
    object.needsLoad = true;
    object.width = 50;
    object.height = 50;
    return ([msg]) => {
        if (msg === "start") {
            ztoggle.onInput(msg);
        }
    };
};
